import { render, staticRenderFns } from "./PromoStatus.vue?vue&type=template&id=425a7907&"
import script from "./PromoStatus.vue?vue&type=script&lang=js&"
export * from "./PromoStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425a7907')) {
      api.createRecord('425a7907', component.options)
    } else {
      api.reload('425a7907', component.options)
    }
    module.hot.accept("./PromoStatus.vue?vue&type=template&id=425a7907&", function () {
      api.rerender('425a7907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Promo/view/PromoStatus.vue"
export default component.exports